<div class="default-block-padding"
  [ngClass]="{ 
    'background-dark-blue': data.backgroundColor == 'darkblue', 
    'background-light-blue': data.backgroundColor == 'lightblue', 
    'background-yellow': data.backgroundColor == 'yellow', 
    'background-gray': data.backgroundColor == 'gray'
  }">

<!--'default-block-padding': data.backgroundColor && (data.backgroundColor == 'darkblue' || data.backgroundColor == 'lightblue' || data.backgroundColor == 'yellow' || data.backgroundColor == 'gray')-->  
<div class="container-fluid">
    <div class="row">
        <div class="col-lg-6 order-lg-2 mb-4 mb-lg-0" *ngIf="data.image">
            <img [src]="data.image.url" [alt]="data.image.alternativeText" class="img-fluid default-border-radius" />
        </div>
        <div class="col-lg-6 order-lg-1" [ngClass]="data.image ? '' : 'col-lg-12 text-center'">
            <div class="content mb-5" [innerHTML]="data.content | bypassSecurity"></div>

            <div class="links">
                <a *ngFor="let link of data.links; let i = index" href="{{link.url}}" target="{{link.openInNewTab ? '_blank' : '_self'}}" 
                    class="btn me-3 mt-3"
                    [ngClass]="data.links.length === 1 ? 'btn-light' : (i % 2 === 0 ? 'btn-dark' : 'btn-light')">
                        {{link.text}} <i class="fa-duotone fa-solid fa-circle-arrow-right fa-duotone-custom-colors"></i>
                    </a>
            </div>
        </div>
    </div>
</div>
</div>
